import React from "react";
import {CommonProps} from "../types/types";

interface SharedMemoProps extends CommonProps {
}

function areSharedEqual<T extends SharedMemoProps>(prev: T, next: T) {
    return prev.value === next.value &&
        prev.errorText === next.errorText &&
        prev.status === next.status &&
        prev.displayText === next.displayText &&
        prev.required === next.required &&
        prev.editable === next.editable;
}

export function withSharedMemo<P extends SharedMemoProps>(Component: React.ComponentType<P>) {
    return React.memo(Component, areSharedEqual);
}